function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M3.47822 12.2664L3.47822 6.04216C3.47822 5.75421 3.71192 5.52051 3.99987 5.52051C4.28782 5.52051 4.52151 5.75421 4.52151 6.04216L4.52151 12.2664C4.52151 12.5544 4.28782 12.7881 3.99987 12.7881C3.71192 12.7881 3.47822 12.5544 3.47822 12.2664Z",
  fill: "#2EAE65"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.05176e-05 6.04207C3.05176e-05 5.9447 0.0271554 5.84872 0.0800157 5.76386L3.55835 0.244153C3.65433 0.0925283 3.82057 2.24113e-05 4.00001 2.24113e-05C4.17946 2.24113e-05 4.34569 0.0925283 4.44167 0.244153L7.92001 5.76386C8.02086 5.92453 8.02712 6.12762 7.93461 6.29386C7.8428 6.46078 7.66823 6.56372 7.47835 6.56372L0.521676 6.56372C0.331797 6.56372 0.157219 6.46078 0.0654097 6.29386C0.0215912 6.21526 3.05176e-05 6.12832 3.05176e-05 6.04207Z",
  fill: "#2EAE65"
});

function SvgArrowup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowup);
export default __webpack_public_path__ + "static/media/arrowup.67c98747.svg";
export { ForwardRef as ReactComponent };